import { useEffect, useState } from 'react';
import { updateCp } from '../../redux/cp/cpSlice';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment/moment';
import 'moment/locale/es';

const useHook = () => {
  const dispatch = useDispatch();
  const reduxCp = useSelector((state: any) => state.cp.cp);
  const [cp, setCp] = useState("");
  const [loading, setLoading] = useState(false);
  const [shipping, setShipping] = useState<any>([]);

  const diasDePreparacion = 3;

  const hoy = moment();
  const fechaEntrega = sumarDiasHabiles(hoy, diasDePreparacion);

  function sumarDiasHabiles(fecha: moment.Moment, dias: number) {
    const resultado = fecha.clone();
    let agregados = 0;
    while (agregados < dias) {
      resultado.add(1, 'days');
      const dia = resultado.day();
      if (dia !== 0 && dia !== 6) {
        agregados++;
      }
    }
    return resultado;
  }

  const handleChange = (e: string) => {
    if (/^\d{0,4}$/.test(e)) {
      setCp(e);
      if (e.length === 4) {
        dispatch(updateCp(e));
      }
    }
  };

  const handleClean = () => {
    dispatch(updateCp(""));
    setCp("");
  };

  async function getShipments(cp: string) {
    setLoading(true);
    const body = {
      cp: cp,
    };
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/envios/cotizar2`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (result?.length > 0) {
        const enviosFiltrados = result?.find((envio: any) => envio.modoDeEntrega === "A domicilio");
        if (enviosFiltrados) {
          setShipping(enviosFiltrados ?? []);
        } else {
          console.error("Error al filtrar", enviosFiltrados);
        }
      } else {
        console.error("Error al obtener datos de Andreani", result);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setCp(reduxCp);
    if (typeof window !== 'undefined' && reduxCp?.length === 4) {
      getShipments(reduxCp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxCp]);

  return {
    cp,
    reduxCp,
    loading,
    shipping,
    fechaEntrega,
    handleChange,
    handleClean,
  };
};

export default useHook;
